module.exports = __webpack_public_path__ + "static/grimoire-05dd1ab4080b74adf2643c19821c5263.png";